import { showToast } from "../../../../../features/ui"
import { usePurchasesActions, usePurchasesHooks } from "../../../../purchases"
import { useProductActions } from "../../../actions/productActions"
import { Product } from "../../../state/types"

export const useActions = () => {
    const { getNegativeStockCategoryIds } = usePurchasesHooks()
    const purchasesActions = usePurchasesActions()
    const { saveProducts } = useProductActions()

    const onUpdateSettings = () => showToast('La configuración fue actualizada.')

    const submitAddCategory = async (categoryId: string) => {
        const categoryIds = getNegativeStockCategoryIds()
        if (categoryIds.includes(categoryId)) return
        await purchasesActions().savePurchasesSetting('negativeStockCategoryIds', [...categoryIds, categoryId])
        onUpdateSettings()
    }

    const submitRemoveCategory = async (categoryId: string) => {
        const categoryIds = getNegativeStockCategoryIds().filter(id => id !== categoryId)
        await purchasesActions().savePurchasesSetting('negativeStockCategoryIds', categoryIds)
        onUpdateSettings()
    }

    // Productos con partidas nunca se habilitan
    const submitEnableProducts = async (products: Product[]) => {
        const productsToEnable = products
            .filter(product => !product.loted && !product.allowNegativeStock)
            .map(product => ({ ...product, allowNegativeStock: true }))
        if (productsToEnable.length === 0) return
        await saveProducts(productsToEnable)
        onUpdateSettings()
    }

    const submitDisableProduct = async (product: Product) => {
        await saveProducts([{ ...product, allowNegativeStock: false }])
        onUpdateSettings()
    }

    return {
        submitAddCategory,
        submitRemoveCategory,
        submitEnableProducts,
        submitDisableProduct
    }
}
